import React from 'react'
import ReactDOM from 'react-dom'
import PasswordResetWizard from './PasswordResetWizard.js'
import isLaunched from '../../../isLaunched.js'

Foundation.Login.Dialog.PasswordResetComponent = class extends Foundation.Component {
  constructor (id) {
    super(id)

    isLaunched('login').then(loginIsLaunched => {
      if (loginIsLaunched) {
        let mountPoint
        if (Foundation.MOBILE) {
          const div = jQuery('<div></div>')
          this.view.find('form').replaceWith(div)
          mountPoint = div.get(0)
        }
        else {
          mountPoint = this.view.find('div.loginContainer').remove('>*').get(0)
        }

        this.observe("shown", () => {
          const member = Foundation.Login.Dialog.activeDialog.member()
          ReactDOM.render(
            <PasswordResetWizard member={member} isMobile={Foundation.MOBILE} />,
            mountPoint
          )
        })

        this.observe("hidden", () => {
          ReactDOM.unmountComponentAtNode(mountPoint)
        })
      }
      else {
        this.form = this.registerForm(new Foundation.Form(this.view.find("form")[0]))
        this.form.setSubmitDelegate(this.sendEmail.bind(this))
        this.observe("hidden", this.form.cancelSubmit.bind(this.form))

        this.observe("shown", () => {
          if (!this.form.values()["email"]) {
            var member = Foundation.Login.Dialog.activeDialog.member()
            if (member.get("email")) this.view.find("input[name=email]").val(member.get("email"))
          }
        })
      }
    })
  }

  sendEmail (values) {
    var response = new Foundation.API("POST", "Login/Reminder", values)
    response.then(() => Foundation.Login.Dialog.activeDialog.close())
    return response
  }
}
